/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { Typography, Modal, Button, Row, Col, message, Table, Avatar, Divider, Popconfirm } from 'antd';
import moment from 'moment';
import { DataService } from '../../../config/dataService/dataService';
import { ImagePreview } from '../../common';
import { API_ENDPOINT, BLOOD_GROUPS, FORM_HIDE_TIMEOUT_SECONDS, GENDERS, sleepForXSeconds, UPDATE_REQUEST_STATUS, UPDATE_REQUEST_STATUS_JSON } from '../../../config/config';
import { TableWrapper } from '../../../container/styled';

const { Text, Title } = Typography;

// Dictionary for user-friendly field labels
const FIELD_LABELS = {
  name: 'Name',
  father_name: 'Father\'s Name',
  cnic: 'CNIC',
  contact: 'Contact',
  date_of_birth: 'Date of Birth',
  blood_group_id: 'Blood Group',
  is_biometric_verified: 'Nadra Verified',
  is_police_verified: 'Police Verified',
  // profile_picture: 'Profile Picture',
  gender_id: 'Gender',
  designation_id: 'Designation',
};

const DetailsDialog = ({ showDialog, isEdit = false, setReload, editId }) => {
  const [busy, setBusy] = useState(false);
  const [data, setData] = useState({ request: {}, changes: [] });
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const fetchDetails = async (id) => {
    try {
      setBusy(true);
      const response = await DataService.post('/update-reqs/get-by-id', { id });
      if (response.data.status) {
        setData(response.data.data);
      } else {
        message.error(response.data.message || response.message);
      }
      setBusy(false);
    } catch (error) {
      setBusy(false);
      console.error('Error fetching details:', error);
      message.error(error.message);
    }
  };

  const handleCancel = async () => {
    try {
      setBusy(true);
      const response = await DataService.post('/update-reqs/cancel-request', { id: editId });
      if (response.data.status) {

        message.success(response.data.message, FORM_HIDE_TIMEOUT_SECONDS, () => {
          setBusy(false);
          setReload(true);
          showDialog(false);
        });
      } else {
        setBusy(false);
        message.error(response.data.message);
      }
    } catch (error) {
      setBusy(false);
      console.error('Error canceling request:', error);
      message.error('Failed to cancel the request.');
    }
  };

  useEffect(() => {
    if (isEdit && editId) {
      fetchDetails(editId);
    }
  }, [isEdit, editId]);

  if (!data) {
    return null;
  }

  const { request, changes } = data;
  // Sort changes to bring profile_picture to the top
  const sortedChanges = [...changes].sort((a, b) =>
    a.field_name === 'profile_picture' ? -1 : b.field_name === 'profile_picture' ? 1 : 0
  );

  // Table columns for the Changes Section
  const columns = [
    {
      title: 'Field',
      dataIndex: 'field_name',
      key: 'field_name',
      render: (field) => <h6 className='text-black'>{FIELD_LABELS[field] || field}</h6>,
    },
    {
      title: 'Old Value',
      dataIndex: 'old_value',
      key: 'old_value',
      render: (value, record) => {
        if (record.field_name === 'gender_id') {
          return (
            <div className="flex justify-center items-center">
              <Text style={{ color: 'green' }}>{GENDERS.find(item => item.id === Number(value))?.label || 'N/A'}</Text>
            </div>
          )
        }

        if (record.field_name === 'designation_id') {
          return (
            <div className="flex justify-center items-center">
              <Text style={{ color: 'green' }}>{record.old_desig_title}</Text>
            </div>
          )
        }

        if (record.field_name === 'date_of_birth') {
          return (
            <div className="flex justify-center items-center">
              <Text style={{ color: 'green' }}>{moment(value).format('D MMM YYYY')}</Text>
            </div>
          )
        }
        if (record.field_name === 'blood_group_id') {
          return (
            <div className="flex justify-center items-center">
              <Text style={{ color: 'green' }}>{BLOOD_GROUPS.find(item => item.id === Number(value))?.label || 'N/A'}</Text>
            </div>
          )
        }
        if (record.field_name === 'is_biometric_verified' || record.field_name === 'is_police_verified') {
          const isVerified = Boolean(value);
          return (
            <div className="flex justify-center items-center">
              <Text style={{ color: 'green' }}>{isVerified ? 'Verfied' : 'Not Verified'}</Text>
            </div>
          )
        }
        return (
          <div className="flex justify-center items-center">
            {record.field_name === 'profile_picture' ? (
              <Avatar
                className='cursor-pointer'
                src={value ? `${API_ENDPOINT}/${value}` : require('../../../static/img/avatar/profileImage.png')}
                size={50}
                onClick={(event) => {
                  if (value) {
                    setSelectedImage(`${API_ENDPOINT}/${value}`);
                    setIsImageModalOpen(true);
                  } else {
                    message.info('No profile image');
                  }
                }}
              />
            ) : (
              <Text style={{ color: 'green' }}>{value || 'N/A'}</Text>
            )}
          </div>
        )
      }
    },
    {
      title: 'New Value',
      dataIndex: 'new_value',
      key: 'new_value',
      render: (value, record) => {
        if (record.field_name === 'gender_id') {
          return (
            <div className="flex justify-center items-center">
              <Text style={{ color: 'blue' }}>{GENDERS.find(item => item.id === Number(value))?.label || 'N/A'}</Text>
            </div>
          )
        }
        if (record.field_name === 'date_of_birth') {
          return (
            <div className="flex justify-center items-center">
              <Text style={{ color: 'blue' }}>{moment(value).format('D MMM YYYY')}</Text>
            </div>
          )
        }
        if (record.field_name === 'blood_group_id') {
          return (
            <div className="flex justify-center items-center">
              <Text style={{ color: 'blue' }}>{BLOOD_GROUPS.find(item => item.id === Number(value))?.label || 'N/A'}</Text>
            </div>
          )
        }

        if (record.field_name === 'designation_id') {
          return (
            <div className="flex justify-center items-center">
              <Text style={{ color: 'blue' }}>{record.new_desig_title}</Text>
            </div>
          )
        }

        return (
          <div className="flex justify-center items-center">
            {record.field_name === 'profile_picture' ? (
              <Avatar
                className='cursor-pointer'
                src={value ? `${API_ENDPOINT}/${value}` : require('../../../static/img/avatar/profileImage.png')}
                size={50}
                onClick={(event) => {
                  if (value) {
                    setSelectedImage(`${API_ENDPOINT}/${value}`);
                    setIsImageModalOpen(true);
                  } else {
                    message.info('No profile image');
                  }
                }}
              />
            ) : (
              <Text style={{ color: 'blue' }}>{value || 'N/A'}</Text>
            )}
          </div>
        )
      }
    },
  ];

  return (
    <Modal
      open
      title="Update Request Details"
      footer={null}
      centered
      width="70%"
      confirmLoading={busy}
      onCancel={() => showDialog(false)}
      destroyOnClose
    >
      <Row gutter={[16, 16]}>
        <Col span={8} className='flex justify-center items-center border-r-2 border-red-200'>
          <Avatar
            className='cursor-pointer'
            src={request.profile_picture ? `${API_ENDPOINT}/${request.profile_picture}` : require('../../../static/img/avatar/profileImage.png')}
            size={150}
            onClick={(event) => {
              if (request.profile_picture) {
                setSelectedImage(`${API_ENDPOINT}/${request.profile_picture}`);
                setIsImageModalOpen(true);
              } else {
                message.info('No profile image');
              }
            }}
          />
        </Col>
        <Col span={10}>
          <Title level={4}>{request?.employee_name}</Title>
          <Text strong>Father&apos;s Name:</Text> <Text className='text-black text-lg'>{request?.father_name}</Text>
          <br />
          <Text strong>CNIC:</Text> <Text className='text-black text-lg '>{request?.cnic}</Text>
          <br />
          <Text strong>Contact:</Text> <Text className='text-black text-lg'>{request?.contact}</Text>
          <br />
          <Text strong>Date of Birth:</Text> <Text className='text-black text-lg'>{request?.date_of_birth && moment(request.date_of_birth).format('DD-MM-YYYY')}</Text>
          <br />
          <Text strong>Blood Group:</Text> <Text className='text-black text-lg'>{request?.blood_group_id && BLOOD_GROUPS.find(item => item.id === request.blood_group_id)?.label}</Text>
          <br />
          <Text strong>Gender:</Text> <Text className='text-black text-lg'>{request?.gender_id && GENDERS.find(item => item.id === request.gender_id)?.label}</Text>
          <br />
          <Text strong>Designation:</Text> <Text className='text-black text-lg'>{request?.desig_title}</Text>
          {request?.res_remarks && <>
            <br />
            <Text strong>HQ Remarks:</Text> <Text className='text-black font-bold text-lg'>{request?.res_remarks}</Text>
          </>
          }
        </Col>
      </Row>
      <Divider className='bg-red-200' />
      {/* Changes Section */}
      <div className="mt-2">
        <span className='text-black font-bold'>Fields to be Updated</span>
        <div className="ninjadasj-datatable">
          <TableWrapper >
            <Table
              rowKey="field_name"
              loading={busy}
              // dataSource={changes}
              dataSource={sortedChanges}
              columns={columns}
              bordered
              virutal
              size='middle'
              className='border rounded drop-shadow-sm'
              pagination={false}
              scroll={{ y: 'calc(100vh - 600px)' }} // Adjust height based on dialog size
            />
          </TableWrapper>
        </div>
      </div>
      <div className="flex justify-end space-x-2 mt-10">
        <Button
          type="default"
          onClick={() => showDialog(false)}
          disabled={busy}
        >
          Close
        </Button>
        {(Number(request?.status) === UPDATE_REQUEST_STATUS_JSON.PENDING) ? <Popconfirm
          title='Please confirm your action !'
          onConfirm={handleCancel}
          okText="Yes, Confirm"
          cancelText="No, Cancel"
          autoAdjustOverflow
          destroyTooltipOnHide
          disabled={busy}
          cancelButtonProps={{
            disabled: busy,
          }}
        >
          <Button
            type="danger"
            loading={busy}
            disabled={busy}
          >
            Cancel
          </Button>
        </Popconfirm> : ''}
      </div>

      <ImagePreview
        visible={isImageModalOpen}
        imageSrc={selectedImage}
        onClose={() => setIsImageModalOpen(false)}
      />
    </Modal>
  );
};

export default DetailsDialog;
